// extracted by css-extract-rspack-plugin
export default {"metricTabs":"a07xB","metricTab":"FNYQ9"};